import { OrderRoutes } from '../orders-routes.enum';
import { FlowDefinition } from './flow.types';

export const WIRELESS_FLOW: FlowDefinition = [
    {
        route: OrderRoutes.WIRELESS_SETUP,
        next: ctx => (ctx.isNewWirelessCustomer() && ctx.orderType() === 'smbnew')
            ? OrderRoutes.BUSINESS_VERIFICATION
            : OrderRoutes.CREDIT_CHECK,
        back: OrderRoutes.BUNDLE_HOMEPAGE
    },
    {
        route: OrderRoutes.BUSINESS_VERIFICATION,
        next: OrderRoutes.CREDIT_CHECK,
        back: OrderRoutes.WIRELESS_SETUP
    },
    {
        route: OrderRoutes.WIRELESS_ID_AUTHENTICATION,
        next: ctx => ctx.creditDecisionNextRoute(undefined, true),
        back: OrderRoutes.CREDIT_CHECK
    },
    {
        route: OrderRoutes.MOBILE_BUSINESS_AGREEMENT,
        next: OrderRoutes.LINE_CONFIGURATION,
        back: OrderRoutes.CREDIT_CHECK
    },
    {
        route: OrderRoutes.SIGFAN,
        next: OrderRoutes.LINE_CONFIGURATION,
        back: OrderRoutes.BUNDLE_HOMEPAGE
    },
    {
        route: OrderRoutes.LINE_CONFIGURATION,
        next: (ctx, data) => data?.wirelessOffersAvailable ? OrderRoutes.ADDITIONAL_WIRELESS_OFFERS
            : data?.inStoreOnly ? OrderRoutes.PRODUCT_SUMMARY
            : data?.needsShipping ? OrderRoutes.ALTERNATE_SHIPPING
            : OrderRoutes.PRODUCT_SUMMARY,
        back: OrderRoutes.CREDIT_CHECK
    },
    {
        route: OrderRoutes.ADDITIONAL_WIRELESS_OFFERS,
        next: (ctx, data) => data?.inStoreOnly ? OrderRoutes.PRODUCT_SUMMARY
            : data?.needsShipping ? OrderRoutes.ALTERNATE_SHIPPING
            : OrderRoutes.PRODUCT_SUMMARY,
        back: OrderRoutes.LINE_CONFIGURATION
    },
    {
        route: OrderRoutes.ALTERNATE_SHIPPING,
        next: (ctx, data) => data?.shippedInventory
            ? OrderRoutes.SERVICE_LEVEL_SELECTION
            : OrderRoutes.PRODUCT_SUMMARY,
        back: (ctx, data) => data?.wirelessOffersAvailable
            ? OrderRoutes.ADDITIONAL_WIRELESS_OFFERS
            : OrderRoutes.LINE_CONFIGURATION
    },
    {
        route: OrderRoutes.SERVICE_LEVEL_SELECTION,
        next: OrderRoutes.PRODUCT_SUMMARY,
        back: OrderRoutes.ALTERNATE_SHIPPING
    },
    {
        route: OrderRoutes.CUSTOMER_ACCOUNT_SETUP,
        next: OrderRoutes.PRODUCT_SUMMARY,
        back: ctx => ctx.allowShippingAddressChange()
            ? OrderRoutes.ALTERNATE_SHIPPING
            : OrderRoutes.ADDITIONAL_WIRELESS_OFFERS
    },
    {
        route: OrderRoutes.PRODUCT_SUMMARY,
        next: OrderRoutes.ORDER_OPTIONS,
        back: OrderRoutes.LINE_CONFIGURATION
    }
];
